import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, OctagonX } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const RunningJobs = () => {
  const [jobs, setJobs] = useState(null);
  const [busy, setBusy] = useState(null);
  const load = useCallback(() => http.get("/ops/running").then((r) => setJobs(r.data.jobs)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [load]);
  const stop = async (key) => {
    setBusy(key);
    try { await http.post(`/ops/stop/${key}`); toast.success(key === "all" ? "Everything stopped — finished work is kept" : "Stopped — finished work is kept"); await load(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  if (!jobs?.length) return <p data-testid="running-jobs-none" className="mb-6 text-xs text-stone-400">Nothing running right now.</p>;
  return (
    <section data-testid="running-jobs" className="mb-6 rounded-lg border border-red-200 bg-red-50/50 p-4">
      <div className="mb-3 flex items-center justify-between gap-4">
        <h2 className="text-sm font-bold uppercase tracking-wide text-red-800">Running now</h2>
        <button data-testid="stop-everything-btn" onClick={() => stop("all")} disabled={!!busy}
          className="inline-flex items-center gap-1.5 rounded-sm bg-red-700 px-3 py-1.5 text-xs font-bold text-white hover:bg-red-800 transition-colors disabled:opacity-60">
          {busy === "all" ? <Loader2 size={13} className="animate-spin" /> : <OctagonX size={13} />} Stop everything
        </button>
      </div>
      <ul className="divide-y divide-red-100">
        {jobs.map((j) => (
          <li key={j.key} data-testid={`running-job-${j.key}`} className="flex items-center justify-between gap-4 py-2 text-sm">
            <span><b className="text-[#2B2A26]">{j.label}</b> <span className="text-stone-500">· {j.detail}</span></span>
            <button data-testid={`stop-job-${j.key}`} onClick={() => stop(j.key)} disabled={!!busy}
              className="inline-flex items-center gap-1 rounded-sm border border-red-700 px-3 py-1 text-xs font-bold text-red-700 hover:bg-red-700 hover:text-white transition-colors disabled:opacity-60">
              {busy === j.key ? <Loader2 size={12} className="animate-spin" /> : <OctagonX size={12} />} Stop
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
